'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isEmailValid = function isEmailValid() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var normalizedString = value.trim().toLowerCase(); // eslint-disable-next-line no-control-regex,no-useless-escape

  var EMAIL_REGEXP = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/;
  return EMAIL_REGEXP.test(normalizedString);
};

exports.isEmailValid = isEmailValid;
//# sourceMappingURL=isValid.js.map
